var handleDetail = window.location.pathname.split("/");

handleDetail = handleDetail[handleDetail.length - 1];

var getShopId = localStorage.getItem("shopId");

getStoreList();

function getStoreList() {
  var storeInfo;
  const getLoginInfo = ShopifyAnalytics.meta.page.customerId; //是否登录
  var paramsStoreInfo = {
    shop_id: shopIdAuth,
    product_handle: handleDetail,
    search_shop_id: "63907102918",
  };
  // 已登陆
  // if (getLoginInfo) {
  //   storeInfo = `${heychic_api}/web/product/searchCustomerProductAppointment`;
  // } else {
  //   storeInfo = `${heychic_api}/web/product/searchProductAppointment`;
  // }

  fetch(`${heychic_api}/web/retail/store/listByProduct?product_handle=${handleDetail}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: authorization,
      "X-Shop-Id": shopIdAuth,
    }
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.code == 200 && data.data.length > 0) {
        $(".find-store").css("display", "block");
        localStorage.setItem("storeList", JSON.stringify(data.data));
      }

      if(data.code == 400){
        if(data.data.store_is_no == 1 || data.data.length == 0){
            $(".find-store").css("display", "none");
        }
      }
      if(data.code == 401){
        deleteAllCookies();
        window.location.href = '/account/logout'; 
      }
    })
    .catch((error) => console.error("Error fetching data:", error));
}


function preOrder(variantId) {
    var paramsStoreInfo = {
      shop_id: shopIdAuth,
      appointment_variant_id: variantId,
      appointment_shop_id: "63907102918",
    };
    var orderInfo = `${heychic_api}/web/product/retailProductAppointment`;

  
    fetch(orderInfo, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: authorization,
        "X-Shop-Id": shopIdAuth,
      },
      body: JSON.stringify(paramsStoreInfo), // 请求体，转为 JSON 字符串
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.code == 200) {
            preBtn.innerHTML = `<div class='pre-btn-no'>RESERVED</div>`;
            getStoreList();
        }
  
        if(data.code == 401){
          deleteAllCookies();
          window.location.href = '/account/logout'; 
        }
      })
      .catch((error) => console.error("Error fetching data:", error));
  }